import {
  AZURE_SOURCE_TYPE_KEY,
  CSV_SOURCE_TYPE_KEY,
  GOOGLE_SOURCE_TYPE_KEY,
  LDAP_SOURCE_TYPE_KEY,
  UKG_SOURCE_TYPE_KEY,
  OKTA_SOURCE_TYPE_KEY,
} from 'pages/Directory/consts';

const HEADER_NAMES = {
  [CSV_SOURCE_TYPE_KEY]: 'Column Header',
  [AZURE_SOURCE_TYPE_KEY]: 'Microsoft Graph User Property',
  [GOOGLE_SOURCE_TYPE_KEY]: 'Google User Property',
  [LDAP_SOURCE_TYPE_KEY]: 'LDAP User Property',
  [UKG_SOURCE_TYPE_KEY]: 'UKG User Property',
  [OKTA_SOURCE_TYPE_KEY]: 'Okta User Property',
};

export default function getSourceHeaderCopy(sourceType: string) {
  // @ts-ignore
  return HEADER_NAMES[sourceType] || `${sourceType} User Property`;
}
